import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectMobileComponent } from './select-mobile.component';
import { SelectMobileDialogComponent } from './select-mobile-dialog/select-mobile-dialog.component';
import { MatRadioModule } from '@angular/material/radio';



@NgModule({
  declarations: [SelectMobileComponent, SelectMobileDialogComponent],
  exports: [SelectMobileComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatRadioModule
  ]
})
export class SelectMobileModule { }
